/**
 * @file 재로그인 모달, 미사용 경고를 항상 맨 위 다이얼로그로 유지
 * @description MUI 는 가장 나중에 열린 다이얼로그만 포커스를 가진다 (Modal/ModalManager isTopModal)
 *              모달이 떠 있는 동안 공지 팝업 등 다른 다이얼로그가 열리면, 그 다이얼로그가 포커스를 가져가서 입력이 안 된다
 *              → 다른 다이얼로그가 열리면 key 를 바꿔 우리 다이얼로그를 다시 열어 맨 뒤(맨 위)로 보낸다
 *              입력값은 다이얼로그 밖(컴포넌트 state)에 있어서 그대로 남는다
 */
import { useState, useEffect } from 'react'

// 우리 다이얼로그 root 에 붙이는 class (자기 자신이 다시 열릴때는 무시)
export const STAY_ON_TOP_CLASS = 'lsv-stay-on-top'

// MUI Modal 의 root (Dialog, Popover 등은 body 에 role="presentation" 으로 붙는다)
const isOtherModal = (node: Node) => (
    node instanceof HTMLElement &&
    node.getAttribute('role') === 'presentation' &&
    !node.classList.contains(STAY_ON_TOP_CLASS)
)

export default function useStayOnTop(open: boolean) {
    const [ key, setKey ] = useState(0)

    useEffect(() => {
        if (!open || typeof MutationObserver === 'undefined') return

        const observer = new MutationObserver(mutations => {
            const opened = mutations.some(c => Array.from(c.addedNodes).some(isOtherModal))
            if (opened) setKey(prev => prev + 1)
        })

        observer.observe(document.body, { childList: true })

        return () => observer.disconnect()
    }, [open])

    return key
}
